import { Loader2 } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

// Badge de andamento do pipeline (spinner + cor por etapa), no lugar dos
// antigos cartões azuis de progresso. Usado ao lado do título na show e nos
// cards da listagem; estados sem pipeline em andamento não renderizam nada.
const PROGRESS_BADGES: Record<string, { label: string; className: string }> = {
  document_generating: {
    label: 'Preparando o processo',
    className: 'bg-violet-500/12 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300',
  },
  skill_generating: {
    label: 'Preparando o agente',
    className: 'bg-blue-500/12 text-blue-700 dark:bg-blue-500/15 dark:text-blue-300',
  },
  publication_pending: {
    label: 'Finalizando a publicação',
    className: 'bg-cyan-500/12 text-cyan-700 dark:bg-cyan-500/15 dark:text-cyan-300',
  },
}

export default function ProcessProgressBadge({ progressKind }: { progressKind: string }) {
  const badge = PROGRESS_BADGES[progressKind]
  if (!badge) return null

  return (
    <Badge
      variant="secondary"
      data-testid="processo-progresso-badge"
      className={`gap-1.5 ${badge.className}`}
    >
      <Loader2 aria-hidden="true" className="size-3 animate-spin motion-reduce:animate-none" />
      {badge.label}
    </Badge>
  )
}
